// @vendors
import { React, useContext, useEffect } from "react"
import { Form } from 'antd'
import Context from '../../../context/appContext';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import LoadingField from "../loading-field";


export default function Recaptcha({ info, form, key }) {

    const { dataForm: { formResponses, hiddenFields, disabledFields }, customRequest,
        formStatus: { steps, currentStep, currentQuestion, numberQuestionsStep, isGoToBack }, setDisabledButtonContinue, setFormStatus, setReturnButton } = useContext(Context);
    const validate = info.validate ? info.validate : {};
    const { executeRecaptcha } = useGoogleReCaptcha();


    useEffect(() => { executeRecaptcha && handleReCaptchaVerify() }, [executeRecaptcha])

    const next = () => {
        const currentQuestionValue = isGoToBack ?
            currentQuestion > 0 ? currentQuestion - 1 : currentQuestion
            : currentQuestion < numberQuestionsStep - 1 ? currentQuestion + 1 : 0;

        const currentStepValue = isGoToBack ? currentQuestion == 0 ? currentStep - 1 : currentStep
            : currentQuestion == numberQuestionsStep - 1 ? currentStep + 1 : currentStep;

        setFormStatus({
            steps,
            currentStep: currentStepValue,
            currentQuestion: currentQuestionValue,
            numberQuestionsStep: steps[currentStepValue]?.questions.length,
            isGoToBack
        });
    };

    const handleReCaptchaVerify = async () => {
        const verify = process.env.REACT_APP_CAPTCHA_VERIFY;
        setDisabledButtonContinue(true);
        setReturnButton(false);
        if (verify && verify === '1') {
            const token = await executeRecaptcha();
            if (token) {
                const requestOptions = JSON.parse(process.env.REACT_APP_CAPTCHA_VERIFY_SERVICE);
                const url = `${requestOptions.url}?token=${Buffer.from(token).toString('base64')}`;
                const response = await customRequest(url, requestOptions.headers, requestOptions.method, {});
                if (response && response.respuesta && response.respuesta.success) {
                    setCaptchaResponse()
                }
            }
        } else {
            setCaptchaResponse()
        }
    }

    const setCaptchaResponse = () => {
        info.value = true;
        const index = formResponses.findIndex(x => x.key === info.key);
        index != -1 ? formResponses[index].value = true : formResponses.push(info);
        form.setFieldsValue({ [info.key]: true });
        !hiddenFields[info.key] && next();
        setDisabledButtonContinue(false);
        setReturnButton(true);
    }

    return hiddenFields[info.key] || isGoToBack ? (
        <Form.Item
            name={info.key}
            key={key}
            rules={[
                {
                    required: hiddenFields[info.key] || disabledFields[info.key] || info.disabled ? false : validate.required,
                    message: ""
                }]}
        />
    ) : <LoadingField />
}